import React, { useEffect } from 'react';
import TabPageContainer from '~components/atoms/TabPageContainer';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import ProjectApprovalTableSearchAndFilterBar from './ProjectApprovalSearchAndFilterBar';
import ProjectApprovalTable from './ProjectApprovalTable';
import ProjectApprovalTablePaginator from './ProjectApprovalPagination';
import ConfirmUpdateProjectStatusModal from './ConfirmUpdateProjectStatusModal';

const ProjectApproval = () => {
    const dispatch = useAppDispatch();

    const projectListingIndex = useAppSelector(state => state.approval.pendingProjectListing.index);

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingProjectListingAttempt());
    }, [projectListingIndex]);

    return (
        <TabPageContainer>
            <ProjectApprovalTableSearchAndFilterBar />

            <ProjectApprovalTable />

            <ProjectApprovalTablePaginator />

            <ConfirmUpdateProjectStatusModal />
        </TabPageContainer>
    );
};

export default ProjectApproval;
